import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import swal from 'sweetalert2';
import { CadastrarMarcaComponent } from '../marca/cadastrar-marca/cadastrar-marca.component';
import { CadastraCombinacaoModalComponent } from '../modals/cadastra-combinacao-modal/cadastra-combinacao-modal.component';
import { MicInvCombModalComponent } from '../modals/mic-inv-comb-modal/mic-inv-comb-modal.component';
import { MicInvComb } from '../models/mic-inv-comb';
import { ParametrosKit } from '../models/parametros-kit';
import { Produto } from '../models/produto';
import { CarregandoService } from '../services/carregando.service';
import { MicInvCombService } from '../services/mic-inv-comb.service';
import { NotificacaoService } from '../services/notificacao.service';
import { ParametrosKitService } from '../services/parametros-kit.service';
import { ProdutoService } from '../services/produto.service';
import { UtilitarioService } from '../services/utilitario.service';
import { ItemFormulaGeral } from '../models/item-formula-geral';
import { ItemFormulaGeralService } from '../services/item-formula-geral.service';
import { ProdutosModalComponent } from '../modals/produtos-modal/produtos-modal.component';
import { ItemPedido } from '../models/pedido';
import { FormulaItemEstruturaModalComponent } from '../modals/formula-item-estrutura-modal/formula-item-estrutura-modal.component';
import { FuncionarioService } from '../services/funcionario.service';
import { GlobalService } from '../services/global.service';
import { AgrupamentoStringboxService } from '../services/agrupamento-stringbox.service';
import { ImportarAgrupamentoStringboxModalComponent } from '../modals/importar-agrupamento-stringbox-modal/importar-agrupamento-stringbox-modal.component';
import { PremissasSistema } from '../models/premissas-sistema';
import { PremissasService } from '../services/premissas.service';
import { AgrupamentoStringbox } from '../models/agrupamento-stringbox';
import { CadastrarAgrupamentoStringboxModalComponent } from '../modals/cadastrar-agrupamento-stringbox-modal/cadastrar-agrupamento-stringbox-modal.component';
import { ProdutosV2ModalComponent } from "../modals/produtos-v2-modal/produtos-v2-modal.component";
import { TipoFiltroProduto } from "../models/enum";

// jquery
declare const $: any;

@Component({
  selector: 'app-combinacao-kits',
  templateUrl: './combinacao-kits.component.html',
  styleUrls: ['./combinacao-kits.component.scss']
})
export class CombinacaoKitsComponent implements OnInit, AfterViewInit {
  paginacao = { tamanhoMaximo: 10, total: 0, paginaAtual: 1 };
  itensPorPagina = 10;
  parametros: any[] = [];
  parametrosDoCabo: any[] = [];
  parametrosDoCombo: any[] = [];
  produtos: any[] = [];
  listaDeItensPorPagina = [10, 30, 50];
  produtosFiltrados: any[] = [];
  microInversores: any[] = [];
  carregando = true;
  fases = [
    { id: null, nome: 'Todos' },
    { id: 0, nome: 'Monofásico' },
    { id: 2, nome: 'Trifásico' }
  ];
  qtds: any[] = [];
  faseSelecionada: any;
  descricao: any;

  tabAlvo = 0;
  tabIndex = 0;
  qtdSelecionada = 1;

  status = [{ id: '', nome: 'Todos' }, { id: 'A', nome: 'Ativo' }, { id: 'B', nome: 'Bloqueado' }];
  statusSelecionado = 'A';

  statusPainelSelecionado = 'A';
  statusStringBoxSelecionado = 'A';
  statusConectorSelecionado = 'A';

  podeGerarCombAut = false;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  paginacaoMicInvComb = { tamanhoMaximo: 10, total: 0, paginaAtual: 1 };
  itensPorPaginaMicInvComb = 10;
  listaDeItensPorPaginaMicInvComb = [10, 30, 50];
  descricaoMicInvComb: any;

  paginacaoFormula = { tamanhoMaximo: 10, total: 0, paginaAtual: 1 };
  itensPorPaginaFormula = 10;
  listaDeItensPorPaginaFormula = [10, 30, 50];
  descricaoFormula: any = '';
  formulasFiltradas: ItemFormulaGeral[] = [];

  suporte = false;

  premissasSistema: PremissasSistema = new PremissasSistema();

  pCentroDistribuicao = false;

  @ViewChild('paginatorMicInvComb', { static: false }) paginatorMicInvComb: MatPaginator;
  @ViewChild('paginatorFormula', { static: false }) paginatorFormula: MatPaginator;

  constructor(
    private utilitarioService: UtilitarioService,
    private produtoService: ProdutoService,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private parametrosKitService: ParametrosKitService,
    public dialog: MatDialog,
    private micInvCombService: MicInvCombService,
    private itemFormulaGeralService: ItemFormulaGeralService,
    private funcionarioService: FuncionarioService,
    private globalService: GlobalService,
    private agrupamentoStringboxService: AgrupamentoStringboxService,
    private premissasService: PremissasService
  ) { }

  async ngOnInit() {

    await this.buscarPremissasSistema();
    await this.buscarPremissaCentroDeDistribuicao();

    const qtdMax = Math.max(this.premissasSistema.combKitLimiteInversor.monofasico, this.premissasSistema.combKitLimiteInversor.trifasico220, this.premissasSistema.combKitLimiteInversor.trifasico380, this.premissasSistema.combKitLimiteInversor.trifasicoMais380);

    this.qtds.push({ id: null, nome: 'Todos' });
    for (let index = 1; index <= qtdMax; index++) {
      this.qtds.push({ id: index, nome: index.toString() });
    }

    this.qtds = [...this.qtds];

    this.buscarInversores();
    this.buscarParametrosDoCabo();
    this.buscarParametrosDoCombo();
    this.buscarMicroInversores();
    this.buscarPodeGerarCombAut();

    this.suporte = await this.globalService.suporte();
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra('buscarPremissasSistema');
      this.premissasSistema = await this.premissasService.consultarPremissasSistema().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasSistema');
    }
  }

  ativaStatus() {
    this.statusPainelSelecionado = 'A';
    this.statusStringBoxSelecionado = 'A';
    this.statusConectorSelecionado = 'A';
  }

  buscarInversores() {
    this.carregandoService.mostra('buscaProdutos');

    this.produtoService.consultarComPaginacao(this.paginacao.paginaAtual, this.itensPorPagina,
      'Descricao', 'asc', this.descricao, '', this.statusSelecionado, 3, false, undefined, null, this.faseSelecionada, null, null, null, null, null, null, null, null, null, null, null, 0, null, null, null, null, null, null, 'A').subscribe(dados => {
        this.produtosFiltrados = dados.itens;

        if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
          this.itensPorPagina = 10;
        }

        this.paginacao.total = dados.total;

        this.carregando = false;
        this.carregandoService.esconde('buscaProdutos');
      }, (erro) => {
        this.carregandoService.esconde('buscaProdutos');
        this.notificacaoService.erro(erro);
      });
  }

  buscarMicroInversores() {
    this.carregandoService.mostra('buscarMicroInversores');

    this.produtoService.consultarComPaginacao(this.paginacao.paginaAtual, this.itensPorPagina,
      'Descricao', 'asc', this.descricaoMicInvComb, '', 'A', 3, false, undefined, null, null, null, null,
      null, null, null, null, null, null, null, null, true, null, null, null, null, null, null, null, 'A').subscribe(dados => {
        this.microInversores = dados.itens;

        if (this.itensPorPaginaMicInvComb > this.listaDeItensPorPaginaMicInvComb[this.listaDeItensPorPaginaMicInvComb.length - 1]) {
          this.itensPorPaginaMicInvComb = 10;
        }

        this.paginacaoMicInvComb.total = dados.total;


        this.carregando = false;
        this.carregandoService.esconde('buscarMicroInversores');
      }, (erro) => {
        this.carregandoService.esconde('buscarMicroInversores');
        this.notificacaoService.erro(erro);
      });
  }

  buscarCombinacoesDoMicroInversor(microInversor: Produto) {
    this.carregandoService.mostra('buscarCombinacoesDoMicroInversor');

    this.micInvCombService.consultarPorIdMicroInversor(microInversor.idProduto).subscribe(dados => {
      microInversor.combinacoesMicroInversor = dados;
      this.carregando = false;
      this.carregandoService.esconde('buscarCombinacoesDoMicroInversor');
    }, (erro) => {
      this.carregandoService.esconde('buscarCombinacoesDoMicroInversor');
      this.notificacaoService.erro(erro);
    });
  }

  toggleStatusItem(microInversor: Produto, idProduto, ativo) {
    this.carregandoService.mostra('toggleStatusItem');
    this.micInvCombService.alterarStatus(microInversor.idProduto, idProduto, !ativo).subscribe(
      () => {
        this.carregandoService.esconde('toggleStatusItem');
        this.buscarCombinacoesDoMicroInversor(microInversor);
      },
      err => {
        this.carregandoService.esconde('toggleStatusItem');
        this.notificacaoService.erro(err);
      }
    );
  }

  atualizarRegraMicroInversor(microInversor: Produto) {
    this.carregandoService.mostra('atualizarRegraMicroInversor');

    this.produtoService.atualizarRegraMicroInversor(microInversor.idProduto, microInversor.mInvRegra).subscribe(dados => {
      this.carregando = false;
      this.carregandoService.esconde('atualizarRegraMicroInversor');
    }, (erro) => {
      this.carregandoService.esconde('atualizarRegraMicroInversor');
      this.notificacaoService.erro(erro);
    });
  }

  buscarParametros(inversor: Produto) {
    this.buscarParametrosDoInversor(inversor);
    this.buscarParametrosDoConector(inversor);
    this.buscarParametrosDoStringbox(inversor);
  }

  buscarParametrosDoInversor(inversor: Produto) {
    this.carregandoService.mostra('buscarParametrosDoInversor');

    this.parametrosKitService.consultarParametrosKit(1, inversor.idProduto, this.qtdSelecionada, this.statusPainelSelecionado).subscribe(dados => {
      inversor.parametrosInversor = dados;
      this.carregando = false;
      this.carregandoService.esconde('buscarParametrosDoInversor');
    }, (erro) => {
      this.carregandoService.esconde('buscarParametrosDoInversor');
      this.notificacaoService.erro(erro);
    });
  }

  buscarParametrosDoConector(inversor: Produto) {
    this.carregandoService.mostra('buscarParametrosDoConector');

    this.parametrosKitService.consultarParametrosKit(2, inversor.idProduto, null, this.statusConectorSelecionado).subscribe(dados => {
      inversor.parametrosConector = dados;
      this.buscarQtdParametros(inversor, 2);
      this.carregando = false;
      this.carregandoService.esconde('buscarParametrosDoConector');
    }, (erro) => {
      this.carregandoService.esconde('buscarParametrosDoConector');
      this.notificacaoService.erro(erro);
    });
  }

  buscarParametrosDoStringbox(inversor: Produto) {
    this.carregandoService.mostra('buscarParametrosDoStringbox');

    this.parametrosKitService.consultarParametrosKit(3, inversor.idProduto, null, this.statusStringBoxSelecionado).subscribe(dados => {
      inversor.parametrosStringbox = dados;
      this.buscarQtdParametros(inversor, 3);
      this.carregando = false;
      this.carregandoService.esconde('buscarParametrosDoStringbox');
    }, (erro) => {
      this.carregandoService.esconde('buscarParametrosDoStringbox');
      this.notificacaoService.erro(erro);
    });
  }

  buscarQtdParametros(inversor: Produto, tipo: number) {
    this.carregandoService.mostra('consultarQtdCadastrado');

    this.parametrosKitService.consultarQtdCadastrado(inversor.idProduto, tipo).subscribe(qtd => {

      switch (tipo) {
        case 2:
          inversor.qtdParametrosConector = qtd;
          break;

        case 3:
          inversor.qtdParametrosStringBox = qtd;
          break;

        default:
          break;
      }

      this.carregandoService.esconde('consultarQtdCadastrado');
    }, (erro) => {
      this.carregandoService.esconde('consultarQtdCadastrado');
      this.notificacaoService.erro(erro);
    });
  }

  buscarParametrosDoCabo() {
    this.carregandoService.mostra('buscarParametrosDoCabo');

    this.parametrosKitService.consultarParametrosKit(4, null, null, 'A').subscribe(dados => {
      this.parametrosDoCabo = dados;
      this.carregando = false;
      this.carregandoService.esconde('buscarParametrosDoCabo');
    }, (erro) => {
      this.carregandoService.esconde('buscarParametrosDoCabo');
      this.notificacaoService.erro(erro);
    });
  }

  buscarParametrosDoCombo() {
    this.carregandoService.mostra('buscarParametrosDoCombo');

    this.parametrosKitService.consultarParametrosKit(5, null, null, 'A').subscribe(dados => {
      this.parametrosDoCombo = dados;
      this.carregando = false;
      this.carregandoService.esconde('buscarParametrosDoCombo');
    }, (erro) => {
      this.carregandoService.esconde('buscarParametrosDoCombo');
      this.notificacaoService.erro(erro);
    });
  }


  mudaDePagina(pageEvent: PageEvent) {
    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarInversores();
  }

  mudaDePaginaMicInvComb(pageEvent: PageEvent) {
    this.itensPorPaginaMicInvComb = pageEvent.pageSize;
    this.paginacaoMicInvComb.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarMicroInversores();
  }

  mudaDePaginaFormula(pageEvent: PageEvent) {
    this.itensPorPaginaFormula = pageEvent.pageSize;
    this.paginacaoFormula.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarFormulas();
  }
  // mudaDePagina(pageEvent: PageEvent) {

  //   this.produtosFiltrados = this.produtos.slice(pageEvent.pageIndex * pageEvent.pageSize, pageEvent.pageIndex * pageEvent.pageSize + pageEvent.pageSize)
  // }

  adicionarParametro(tipo: any, produto: Produto) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastraCombinacaoModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { tipo: tipo, parametroKit: new ParametrosKit(), produtoPrincipal: produto ? produto.idProduto : null, editando: false },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (tipo === 4) {
          this.buscarParametrosDoCabo();
        }
        else if (tipo === 5) {
          this.buscarParametrosDoCombo();
        }
        else {
          this.buscarParametros(produto);
        }
      }
    });
  }

  editarParametro(parametro: any, tipo: any, produto: Produto) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastraCombinacaoModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { tipo: tipo, parametroKit: Object.assign({}, parametro), produtoPrincipal: produto ? produto.idProduto : null, editando: true },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (tipo === 4) {
          this.buscarParametrosDoCabo();
        } else if (tipo === 5) {
          this.buscarParametrosDoCombo();
        }
        else {
          this.buscarParametros(produto);
        }
      }
    });

  }
  excluirParametro(parametro: any, produto: Produto, tipo: any) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir a Combinação?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {

        this.carregandoService.mostra('excluirParametro');
        this.parametrosKitService.excluir(parametro).subscribe(resp => {

          this.notificacaoService.sucesso('Combinação excluída com sucesso!!!');
          this.carregandoService.esconde('excluirParametro');
          if (tipo === 4) {
            this.buscarParametrosDoCabo();
          } else if (tipo === 5) {
            this.buscarParametrosDoCombo();
          }
          else {
            this.buscarParametros(produto);
          }

        }, (erro) => {
          this.carregandoService.esconde('excluirParametro');
          this.notificacaoService.erro(erro);
        });

      }
    });
  }

  defineTabAlvo(alvo) {
    this.tabAlvo = alvo;

    if (alvo === 4) {
      this.buscarFormulas();
    }
  }

  // atualiza o tabIndex
  proximaTab(e) {
    e.preventDefault();
    this.tabIndex++;

  }

  tabAnterior(e) {
    e.preventDefault();
    this.tabIndex--;

  }


  adicionarMicInvComb(produto: Produto) {

    const novoMicInbComb = new MicInvComb();
    novoMicInbComb.idMicroInversor = produto.idProduto;

    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(MicInvCombModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { micInvComb: novoMicInbComb, editando: false },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarCombinacoesDoMicroInversor(produto);
      }
    });
  }

  editarMicInvComb(micInvComb: MicInvComb, produto: Produto) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(MicInvCombModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { micInvComb: Object.assign({}, micInvComb), editando: true },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarCombinacoesDoMicroInversor(produto);
      }
    });

  }
  excluirMicInvComb(micInvComb: MicInvComb, produto: Produto) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir a Combinação?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {

        this.carregandoService.mostra('excluirParametro');
        this.micInvCombService.excluir(micInvComb.idMicroInversor, micInvComb.idProduto).subscribe(resp => {

          this.notificacaoService.sucesso('Combinação excluída com sucesso!!!');
          this.carregandoService.esconde('excluirParametro');
          this.buscarCombinacoesDoMicroInversor(produto);

        }, (erro) => {
          this.carregandoService.esconde('excluirParametro');
          this.notificacaoService.erro(erro);
        });

      }
    });
  }


  ngAfterViewInit() {

    const elemMainPanel = <HTMLElement>document.querySelector('.main-panel');

    // Wizard Initialization
    $('.card-wizard').bootstrapWizard({
      'tabClass': 'nav nav-pills',
      'nextSelector': '.btn-next',
      'previousSelector': '.btn-previous',

      onNext: function (tab, navigation, index) {
      },

      onInit: function (tab: any, navigation: any, index: any) {

        // check number of tabs and fill the entire row
        let $total = navigation.find('li:not(.d-none)').length;
        let $wizard = navigation.closest('.card-wizard');

        let $first_li = navigation.find('li:first-child a').html();
        let $moving_div = $('<div class="moving-tab">' + $first_li + '</div>');
        $('.card-wizard .wizard-navigation').append($moving_div);

        $total = $wizard.find('.nav li:not(.d-none)').length;
        let $li_width = 100 / $total;

        let total_steps = $wizard.find('.nav li:not(.d-none)').length;
        let move_distance = $wizard.width() / total_steps;
        let index_temp = index;
        let vertical_level = 0;

        let mobile_device = $(document).width() < 600 && $total > 3;

        if (mobile_device) {
          move_distance = $wizard.width() / 2;
          index_temp = index % 2;
          $li_width = 50;
        }

        $wizard.find('.nav li:not(.d-none)').css('width', $li_width + '%');

        let step_width = move_distance;
        move_distance = move_distance * index_temp;

        let $current = index + 1;

        if ($current == 1 || (mobile_device == true && (index % 2 == 0))) {
          move_distance -= 8;
        } else if ($current == total_steps || (mobile_device == true && (index % 2 == 1))) {
          move_distance += 8;
        }

        if (mobile_device) {
          let x: any = index / 2;
          vertical_level = parseInt(x);
          vertical_level = vertical_level * 38;
        }

        $wizard.find('.moving-tab').css('width', step_width);
        $('.moving-tab').css({
          'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
          'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'

        });
        $('.moving-tab').css('transition', 'transform 0s');
      },

      onTabClick: (tab: any, navigation: any, index: any) => {

        if (this.tabIndex !== this.tabAlvo) {
          this.tabIndex = this.tabAlvo;

          return true;
        }

        return false;
      },

      onTabShow: (tab: any, navigation: any, index: any) => {

        // this.atualizar();

        // if (index >= 3) {
        //   window.dispatchEvent(new Event('resize'));
        // }
        // this.vendedores = [...this.vendedores];


        let $total = navigation.find('li:not(.d-none)').length;
        let $current = index + 1;
        elemMainPanel.scrollTop = 0;
        const $wizard = navigation.closest('.card-wizard');

        // If it's the last tab then hide the last button and show the finish instead
        if ($current >= $total) {
          $($wizard).find('.btn-next').hide();
          $($wizard).find('.btn-finish').show();
        } else {
          $($wizard).find('.btn-next').show();
          $($wizard).find('.btn-finish').hide();
        }

        const button_text = navigation.find('li:nth-child(' + $current + ') a').html();

        setTimeout(function () {
          $('.moving-tab').text(button_text);
        }, 150);

        const checkbox = $('.footer-checkbox');

        if (index !== 0) {
          $(checkbox).css({
            'opacity': '0',
            'visibility': 'hidden',
            'position': 'absolute'
          });
        } else {
          $(checkbox).css({
            'opacity': '1',
            'visibility': 'visible'
          });
        }
        $total = $wizard.find('.nav li:not(.d-none)').length;
        let $li_width = 100 / $total;

        let total_steps = $wizard.find('.nav li:not(.d-none)').length;
        let move_distance = $wizard.width() / total_steps;
        let index_temp = index;
        let vertical_level = 0;

        let mobile_device = $(document).width() < 600 && $total > 3;

        if (mobile_device) {
          move_distance = $wizard.width() / 2;
          index_temp = index % 2;
          $li_width = 50;
        }

        $wizard.find('.nav li:not(.d-none)').css('width', $li_width + '%');

        let step_width = move_distance;
        move_distance = move_distance * index_temp;

        $current = index + 1;

        if ($current == 1 || (mobile_device == true && (index % 2 == 0))) {
          move_distance -= 8;
        } else if ($current == total_steps || (mobile_device == true && (index % 2 == 1))) {
          move_distance += 8;
        }

        if (mobile_device) {
          let x: any = index / 2;
          vertical_level = parseInt(x);
          vertical_level = vertical_level * 38;
        }

        $wizard.find('.moving-tab').css('width', step_width);
        $('.moving-tab').css({
          'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
          'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'

        });
      }
    });


    // Prepare the preview for profile picture
    $('#wizard-picture').change(function () {
      const input = $(this);

      if (input[0].files && input[0].files[0]) {
        const reader = new FileReader();

        reader.onload = function (e: any) {
          $('#wizardPicturePreview').attr('src', e.target.result).fadeIn('slow');
        };
        reader.readAsDataURL(input[0].files[0]);
      }
    });

    $('[data-toggle="wizard-radio"]').click(function () {
      const wizard = $(this).closest('.card-wizard');
      wizard.find('[data-toggle="wizard-radio"]').removeClass('active');
      $(this).addClass('active');
      $(wizard).find('[type="radio"]').removeAttr('checked');
      $(this).find('[type="radio"]').attr('checked', 'true');
    });

    $('[data-toggle="wizard-checkbox"]').click(function () {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).find('[type="checkbox"]').removeAttr('checked');
      } else {
        $(this).addClass('active');
        $(this).find('[type="checkbox"]').attr('checked', 'true');
      }
    });

    $('.set-full-height').css('height', 'auto');

    this.rodaScriptTabEnter();

    $(window).resize(() => {
      $('.card-wizard').each(function () {
        setTimeout(() => {
          const $wizard = $(this);
          const index = $wizard.bootstrapWizard('currentIndex');
          let $total = $wizard.find('.nav li:not(.d-none)').length;
          let $li_width = 100 / $total;

          let total_steps = $wizard.find('.nav li:not(.d-none)').length;
          let move_distance = $wizard.width() / total_steps;
          let index_temp = index;
          let vertical_level = 0;

          let mobile_device = $(document).width() < 600 && $total > 3;
          if (mobile_device) {
            move_distance = $wizard.width() / 2;
            index_temp = index % 2;
            $li_width = 50;
          }

          $wizard.find('.nav li:not(.d-none)').css('width', $li_width + '%');

          let step_width = move_distance;
          move_distance = move_distance * index_temp;

          let $current = index + 1;

          if ($current == 1 || (mobile_device == true && (index % 2 == 0))) {
            move_distance -= 8;
          } else if ($current == total_steps || (mobile_device == true && (index % 2 == 1))) {
            move_distance += 8;
          }

          if (mobile_device) {
            let x: any = index / 2;
            vertical_level = parseInt(x);
            vertical_level = vertical_level * 38;
          }

          $wizard.find('.moving-tab').css('width', step_width);
          $('.moving-tab').css({
            'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
            'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'
          });

          $('.moving-tab').css({
            'transition': 'transform 0s'
          });
        }, 500);

      });
    });

    // this.utilitarioService.rodaScriptTabEnter();


  }
  rodaScriptTabEnter() {
    this.utilitarioService.rodaScriptTabEnter();
  }

  selecionarFase() {

  }

  filtra() {
    this.buscarInversores();
  }

  filtraMicInvComb() {
    this.buscarMicroInversores();
  }

  gerarCombinacoes() {
    this.carregandoService.limpaProgresso();
    this.carregandoService.mostraProgresso();

    this.parametrosKitService.gerarCombinacoes().subscribe(dados => {

      this.carregando = false;
      this.carregandoService.escondeProgresso();
    }, (erro) => {
      this.carregandoService.escondeProgresso();
      this.notificacaoService.erro(erro);
    });
  }

  buscarFormulas() {
    this.carregandoService.mostra('buscaFormulas');

    this.itemFormulaGeralService.consultarItemFormulaGeralComPaginacao(this.descricaoFormula, this.paginacaoFormula.paginaAtual, this.itensPorPaginaFormula,
      'Descricao', 'asc').subscribe(dados => {
        this.formulasFiltradas = dados.itens;

        if (this.itensPorPaginaFormula > this.listaDeItensPorPaginaFormula[this.listaDeItensPorPaginaFormula.length - 1]) {
          this.itensPorPaginaFormula = 10;
        }

        this.paginacaoFormula.total = dados.total;

        this.carregando = false;
        this.carregandoService.esconde('buscaFormulas');
      }, (erro) => {
        this.carregandoService.esconde('buscaFormulas');
        this.notificacaoService.erro(erro);
      });
  }

  adicionarFormula() {
    let dialogRef;
    const config = {
      width: ($('body').width()).toString() + 'px',
      data: {
        produtos: [],
        selecionaSomenteUm: true,
      },
      panelClass: 'modal-card',
      // maxHeight: '90vh'
    };

    if (this.premissasSistema.filtroProduto === TipoFiltroProduto.Agrupamento) {
      dialogRef = this.dialog.open(ProdutosModalComponent, config);
    } else {
      dialogRef = this.dialog.open(ProdutosV2ModalComponent, config);
    }

    dialogRef.afterClosed().subscribe((result: ItemPedido[]) => {
      if (result) {
        const produtoSelecionado = result[0];
        const item = new ItemFormulaGeral();
        item.idProduto = produtoSelecionado.produtoTela.idProduto;
        item.produto = produtoSelecionado.produtoTela.descricao;

        this.editarFormula(item);
      }
    });
  }

  editarFormula(item) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(FormulaItemEstruturaModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: {
        formulaGeral: true,
        itemFormulaGeral: Object.assign(new ItemFormulaGeral(), item)
      },
      panelClass: 'modal-card',
      // maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe((result: ItemFormulaGeral[]) => {
      if (result) {
        this.buscarFormulas();
      }
    });
  }

  excluirFormula(item) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir a formula?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {

        this.carregandoService.mostra('excluir');
        this.itemFormulaGeralService.excluir(item.id).subscribe(resp => {

          this.notificacaoService.sucesso('Fórmula excluída com sucesso!!!');
          this.carregandoService.esconde('excluir');
          this.buscarFormulas();

        }, (erro) => {
          this.carregandoService.esconde('excluir');
          this.notificacaoService.erro(erro);
        });

      }
    });

  }

  buscarPodeGerarCombAut() {
    this.carregandoService.mostra('buscarPodeGerarCombAut');

    this.funcionarioService.consultarPodeGerarCombAut().subscribe(valor => {
      this.podeGerarCombAut = valor;
      this.carregandoService.esconde('buscarPodeGerarCombAut');
    }, (erro) => {
      this.carregandoService.esconde('buscarPodeGerarCombAut');
      this.notificacaoService.erro(erro);
    });
  }

  exportarAgrupamentoStringbox() {
    this.carregandoService.mostra('exportarAgrupamentoStringbox');
    this.agrupamentoStringboxService.exportar().subscribe(arq => {
      this.utilitarioService.saveBlob(arq, 'AgrupamentoStringbox.xlsx');
      this.carregandoService.esconde('exportarAgrupamentoStringbox');
    }, (erro) => {
      this.carregandoService.esconde('exportarAgrupamentoStringbox');
      this.notificacaoService.erro(erro);
    });
  }

  importarAgrupamentoStringbox() {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(ImportarAgrupamentoStringboxModalComponent, {
      width: largura > 1050 ? '1000px' : (($('body').width()).toString() + 'px'),
      data: {},
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.filtra();
      }
    });
  }

  novoAgrupamentoStringbox(inversor: any) {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastrarAgrupamentoStringboxModalComponent, {
      width: largura > 850 ? '800px' : (($('body').width()).toString() + 'px'),
      data: { idInversor: inversor.idProduto },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarAgrupamentosStringbox(inversor);
      }
    });
  }

  editarAgrupamentoStringbox(agrupamento: AgrupamentoStringbox, inversor: any) {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastrarAgrupamentoStringboxModalComponent, {
      width: largura > 850 ? '800px' : (($('body').width()).toString() + 'px'),
      data: { idAgrupamento: agrupamento.id, idInversor: inversor.idProduto },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarAgrupamentosStringbox(inversor);
      }
    });
  }

  excluirAgrupamentoStringbox(item, inversor: any) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir esse combo?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {

        this.carregandoService.mostra('excluir');
        this.agrupamentoStringboxService.excluir(item.id).subscribe(resp => {

          this.notificacaoService.sucesso('Combo excluído com sucesso!!!');
          this.carregandoService.esconde('excluir');
          this.buscarAgrupamentosStringbox(inversor);

        }, (erro) => {
          this.carregandoService.esconde('excluir');
          this.notificacaoService.erro(erro);
        });

      }
    });

  }

  alterarSituacaoAgrupamentosStringbox(agrupamento: AgrupamentoStringbox, inversor) {
    this.carregandoService.mostra('alterarSituacaoAgrupamentosStringbox');

    this.agrupamentoStringboxService.alterarSituacao(agrupamento.id, !agrupamento.ativo).subscribe(resp => {
      this.buscarAgrupamentosStringbox(inversor);
      this.carregandoService.esconde('alterarSituacaoAgrupamentosStringbox');
    }, (erro) => {
      this.carregandoService.esconde('alterarSituacaoAgrupamentosStringbox');
      this.notificacaoService.erro(erro);
    });
  }

  buscarAgrupamentosStringbox(inversor: any) {
    this.carregandoService.mostra('buscarAgrupamentosStringbox');

    this.agrupamentoStringboxService.consultarAgrupamentosStringboxPorInversor(inversor.idProduto).subscribe(agrupamentos => {
      inversor.agrupamentos = agrupamentos;
      this.carregandoService.esconde('buscarAgrupamentosStringbox');
    }, (erro) => {
      this.carregandoService.esconde('buscarAgrupamentosStringbox');
      this.notificacaoService.erro(erro);
    });
  }

  alterouAba(index, inversor) {
    if (index === 2) {
      this.buscarAgrupamentosStringbox(inversor);
    }
  }

  async buscarPremissaCentroDeDistribuicao() {
    try {
      this.pCentroDistribuicao = (await this.premissasService.consultarCentroDeDistribuicao().toPromise()).valor;
    } catch (erro) {
      this.notificacaoService.erro(erro);
    }
  }
}
